import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState, } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useScreenSizes } from '@che-ins-ui/theme';
import { InfoIcon } from '@/components/insurance/components/FlightFieldIcons';
import { BREAKPOINTS } from '@/styles/breakpoints';
import { useStyles } from './styles';
export const Tooltip = memo(({ tooltipLabel, position = 'top', isShown = false }) => {
    const classes = useStyles();
    const variants = {
        visible: { opacity: 1, y: 0, scale: 1 },
        hidden: {
            opacity: 0,
            y: -10 * (position === 'top' ? 1 : -1),
            scale: 0.7,
        },
    };
    return (_jsx(AnimatePresence, { children: isShown && tooltipLabel && (_jsx("div", { className: classes.tooltipContainer, "data-position": position, children: _jsxs(motion.div, { className: classes.tooltip, initial: "hidden", animate: "visible", exit: "hidden", variants: variants, transition: {
                    type: 'just',
                    duration: 0.1,
                    opacity: { duration: 0.05 },
                }, "data-position": position, children: [_jsx("div", { className: classes.tooltipBody, children: tooltipLabel }), _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "22", height: "6", className: classes.tooltipArrow, "data-position": position, children: _jsx("path", { d: "M0 0h22c-5.5 0-8.594 2.4-9.735 5.28l-.007.005C12.044 5.706 11.562 6 11 6s-1.044-.294-1.258-.715l-.007-.005C8.594 2.4 5.134 0 0 0" }) })] }, tooltipLabel.toString()) })) }));
});
export const InfoTooltip = ({ isForceShown = false, ...tooltipProps }) => {
    const classes = useStyles();
    const [isShown, setIsShown] = useState(false);
    const { width } = useScreenSizes();
    const isDesktop = width >= BREAKPOINTS.xl;
    const shouldShowTooltip = isShown || isForceShown;
    const stopInputFocus = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!isDesktop) {
            setIsShown((prev) => !prev);
        }
    };
    return (_jsx("div", { className: classes.container, onBlur: () => {
            setIsShown(false);
        }, onMouseEnter: isDesktop ? () => setIsShown(true) : undefined, onMouseLeave: isDesktop ? () => setIsShown(false) : undefined, onFocus: isDesktop ? () => setIsShown(true) : undefined, onPointerDown: stopInputFocus, onMouseDown: stopInputFocus, onClick: handleClick, tabIndex: 0, role: "button", "aria-label": "tooltip", "aria-expanded": shouldShowTooltip, children: _jsxs("div", { className: classes.questionMark, "data-active": shouldShowTooltip, children: [_jsx(InfoIcon, {}), _jsx(Tooltip, { isShown: shouldShowTooltip, ...tooltipProps })] }) }));
};
